import _ from "lodash";
import IDUtils from "../utils/IDUtils";

class DesignUpdate {
  constructor() {
    this.updates = [];
  }

  add(propPath, value, updateAction) {
    var path = _.isArray(propPath) ? propPath : IDUtils.getArray(propPath);
    var action = false;

    //allow normal update action to be overwritten
    if (updateAction) {
      action = updateAction;
    }

    var update = {
      key: path,
      value: value,
      action: action,
    };

    this.updates.push(update);
  }
}

export default DesignUpdate;
